import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  CareerFeedComponent,
  GetCareerFeedDocument,
} from 'src/graphql/graphql';
import { useTimezone } from 'src/hooks/useTimezone';
import { useIsHomeFeedAPIEnabled } from 'src/store/featureFlags/hooks';
import { useSelector } from 'src/store/react';
import { selectServerAuthenticated } from 'src/store/selectors';
import { useMelwaysLocale, useMelwaysZone } from 'src/utils/melwaysHelper';

import { mapQueryToCareerFeedItem } from './feed-types';
import { useVisitorId } from './useHomeRecommendations';

export const useCareerFeed = () => {
  const locale = useMelwaysLocale();
  const zone = useMelwaysZone();
  const visitorId = useVisitorId();
  const isServerAuthenticated = useSelector(selectServerAuthenticated);
  const timezone = useTimezone();
  const isFeedEnabled = useIsHomeFeedAPIEnabled();

  const { data, error, loading } = useQuery(GetCareerFeedDocument, {
    variables: {
      locale,
      zone,
      timezone,
      visitorId,
      components: [CareerFeedComponent.Job],
    },
    ssr: isServerAuthenticated && Boolean(visitorId),
    skip: !isFeedEnabled,
  });

  const feedItems = useMemo(() => mapQueryToCareerFeedItem(data), [data]);

  return {
    feedItems,
    error,
    loading,
    tracking: {
      solMetadata: data?.careerFeed?.solMetadata,
    },
  };
};
